// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.0
// source: menu/item/enums/itemOrderType.enum.proto

/* eslint-disable */

export const protobufPackage = "menu.itemOrderTypeEnum";

export enum EItemOrderType {
  UNSPECIFIED = 0,
  REGULAR = 1,
  SINGLE_REFILL = 2,
  INFINITE_REFILL = 3,
  UNRECOGNIZED = -1,
}

export function eItemOrderTypeFromJSON(object: any): EItemOrderType {
  switch (object) {
    case 0:
    case "UNSPECIFIED":
      return EItemOrderType.UNSPECIFIED;
    case 1:
    case "REGULAR":
      return EItemOrderType.REGULAR;
    case 2:
    case "SINGLE_REFILL":
      return EItemOrderType.SINGLE_REFILL;
    case 3:
    case "INFINITE_REFILL":
      return EItemOrderType.INFINITE_REFILL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EItemOrderType.UNRECOGNIZED;
  }
}

export function eItemOrderTypeToJSON(object: EItemOrderType): string {
  switch (object) {
    case EItemOrderType.UNSPECIFIED:
      return "UNSPECIFIED";
    case EItemOrderType.REGULAR:
      return "REGULAR";
    case EItemOrderType.SINGLE_REFILL:
      return "SINGLE_REFILL";
    case EItemOrderType.INFINITE_REFILL:
      return "INFINITE_REFILL";
    case EItemOrderType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
